import Button from '@ui-library/button';
import React from 'react';
import { useModal } from '@ui-library/modal/ModalProvider';
import ModalContent from './addColumnModalContent';
import { useMappingState } from '../../tableMappingProvider';

const AddColumn = () => {
  const modal = useModal();
  const mappingState = useMappingState();
  return (
    <Button
      className="table-view_add_column"
      onClick={() =>
        modal.show({
          content: <ModalContent mappingState={mappingState} />,
          footer: null,
        })
      }
      name="Add Constant"
    />
  );
};

export default AddColumn;
